/* -------------------------------- KOIN4: Inject badges to AI widget -------------------------------- */

function addBadgesToRebuyProducts() {
    // Specific selector that only targets Rebuy products within product recommendations
    const productBlocks = document.querySelectorAll('.product-recommendations .rebuy-product-block');
  
    productBlocks.forEach(productBlock => {
      // Check if badge container already exists
      if (productBlock.querySelector('.product-item__label-list')) {
        return; // Skip if badge container already exists
      }
  
      // Create a container for badges with the specified class
      const badgeContainer = document.createElement('div');
      badgeContainer.className = 'product-item__label-list';
  
      // Check for sale badge
      const priceContainer = productBlock.querySelector('.rebuy-product-price div');
      if (priceContainer) {
        const salePriceElement = priceContainer.querySelector('.rebuy-money.sale span:last-child');
        const regularPriceElement = priceContainer.querySelector('.rebuy-money.compare-at span:last-child');
  
        if (salePriceElement && regularPriceElement) {
          const salePrice = parseFloat(salePriceElement.textContent.replace(/[^\d.]/g, ''));
          const regularPrice = parseFloat(regularPriceElement.textContent.replace(/[^\d.]/g, ''));
          const savingsPercentage = Math.round(((regularPrice - salePrice) / regularPrice) * 100);
  
          if (savingsPercentage > 0) {
            const saleBadge = document.createElement('span');
            saleBadge.className = 'product-label product-label--on-sale';
            saleBadge.textContent = `Save ${savingsPercentage}%`;
            badgeContainer.appendChild(saleBadge);
          }
        }
      }
  
      // Check for custom label 1
      const label1Class = Array.from(productBlock.classList).find(cls => cls.startsWith('tag-__label') && !cls.startsWith('tag-__label2'));
      if (label1Class) {
        const label1Text = label1Class.replace('tag-__label', '').replace(/-/g, ' ');
        const label1Badge = document.createElement('span');
        label1Badge.className = 'product-label product-label--custom1';
        label1Badge.textContent = label1Text;
        badgeContainer.appendChild(label1Badge);
      }
  
      // Check for custom label 2
      const label2Class = Array.from(productBlock.classList).find(cls => cls.startsWith('tag-__label2'));
      if (label2Class) {
        const label2Text = label2Class.replace('tag-__label2', '').replace(/-/g, ' ');
        const label2Badge = document.createElement('span');
        label2Badge.className = 'product-label product-label--custom2';
        label2Badge.textContent = label2Text;
        badgeContainer.appendChild(label2Badge);
      }
  
      // Append the badge container to the product block, at the same level as product media and info
      if (badgeContainer.childElementCount > 0) {
        productBlock.insertBefore(badgeContainer, productBlock.firstChild);
      }
    });
  }
  
  // Polling function to check for Rebuy product blocks
  function pollForRebuyProducts(startTime) {
    const currentTime = new Date().getTime();
    const productBlocks = document.querySelectorAll('.rebuy-product-block');
  
    if (productBlocks.length > 0) {
      addBadgesToRebuyProducts();
    } else if (currentTime - startTime < 10000) { // 10 seconds timeout
      setTimeout(function() { pollForRebuyProducts(startTime); }, 500);
    }
  }
  
  // Start polling for Rebuy products when the page loads
  window.addEventListener('load', function() {
    pollForRebuyProducts(new Date().getTime());
  });
  
  // Also poll when the cart changes
  document.addEventListener('rebuy:cart.change', function() {
    pollForRebuyProducts(new Date().getTime());
  });